import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { BrandConstants, BrandEnum } from '@infrastructure/brand.enum';
import { CameraEnum } from '@infrastructure/camera.enum';
import { SourceTypeEnum } from '@infrastructure/sourcetype.enum';
import { ImageAndThumb } from '@models/limited-edition-model';
import { MiscImageModel } from '@models/misc-image-model';
import { VariantSizeModel } from '@models/variant-size';
import { AppState } from '@shared/app-state';
import { ModelgroupConstants } from '@shared/modelgroup-constants';
import { ComponentVariantFromApiModel } from '@models/api-models/component-variant-fromapi';
import { ModelModel } from '@models/api-models/model';
import { ImageGetModel, ImageModel } from '@models/image';
import { ModelGroupModel } from '@models/model-group';
import { ComponentVariantModel } from '../_models/component-variant';
import { OrderItemModel } from '../_models/order-item';
import { AngleConstants } from '../shared/angle-constants';
import { ComponentCodeConstants } from '../shared/component-constants';
import { BrandModeService } from './brandmode.service';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

export enum ImageSize {
	'High' = 'high',
	'Medium' = 'medium',
	'Low' = 'low'
}

export enum Background {
	'Default' = 'default',
	'None' = 'none',
	'Precious' = 'precious'
}

export enum ConfigurationMode {
	'undefined',
	'display' = 'display',
	'enduser' = 'enduser'
}

@Injectable({
	providedIn: 'root'
})
export class ImageService {

	private brandModeService = inject(BrandModeService);
	private appState = inject(AppState);

	// private UseRealtime(productline: string | undefined): boolean {
	// 	if (!productline) return false;
	// 	const realtimePreferred = this.userPreferenceStore.threeDeeActive() == true
	// 	const realtimeAllowed = this.userService.currentUser$.value?.ThreeDeeProductLines?.map(x => x.split('_')).some(x => x.at(0) == '3D' && x.at(1) == productline && x.length == 2 || x.at(2) == this.brandModeService.currentBrandStringValue().toUpperCase()) == true
	// 	return realtimeAllowed && realtimePreferred
	// }

	GetImage(model: ModelModel | undefined, variants: ComponentVariantModel[], camera: CameraEnum, size: ImageSize | string = ImageSize.Medium) {
		if (!model) return '';
		const fixCase = (str: string) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
		const url = `${environment.realtimeUrl}/image/${fixCase(camera)}/${fixCase(size)}?productline=${model?.ModelGroupCode?.toUpperCase()}&isRimless=${model?.IsRimless}&MODEL=${model?.Code?.toUpperCase()}+${(model?.ModelSizeCodeModels?.find(x => x.Default)?.ModelsizeCode || (model as any)?.ModelSizeModels?.at(0)?.Code).replace('#', `□`).replace('¤', `○`)}+&${variants?.sortBy(x => x.Component.Code).filter(x => !x.Optional || x.VariantColor?.Color?.Code).map(x => `${x.Component.Code}=${x.Code?.replace(' ', '')}+${x.VariantSize?.Size}+${x.VariantColor?.Color?.ColorLine?.Code?.replace(' ', '-')}/${x.VariantColor?.Color?.Code}`).join('&')}`
		return url;
	}

	// public GetFrontImage(model: ModelModel | undefined | null, modelGroupCode: string | undefined, configurationCode: string | undefined, variants: Array<ComponentVariantModel> | undefined, size: ImageSize | string, background: Background = Background.Default, usePreciousCheck: boolean = true): string {
	public GetFrontImage(model: ModelModel | undefined | null, variants: Array<ComponentVariantModel> | undefined, size: ImageSize | string): string {
		return this.GetImage(model!, variants!, CameraEnum.FRONT, size)

		// if (this.UseRealtime(model?.ProductLineCode)) return this.GetImage(model!, variants!, CameraEnum.FRONT, size)
		// variants = this.adjustForBrandMode(variants, model?.PresentAsPrecious);

		// const imageGetModel = this.GetImageModel(model, modelGroupCode, configurationCode, variants, AngleConstants.Front);
		// imageGetModel.ComponentColorList = this.GetComponentParameters(variants);
		// imageGetModel.Angle = AngleConstants.Front;

		// return this.GetImageUrl(imageGetModel, size, background, usePreciousCheck);
	}

	// public GetPerspectiveImage(model: ModelModel | undefined | null, modelGroupCode: string | undefined, configurationCode: string | undefined, variants: Array<ComponentVariantModel> | undefined, size: ImageSize | string, background: Background): string {
	public GetPerspectiveImage(model: ModelModel | undefined | null, variants: Array<ComponentVariantModel> | undefined, size: ImageSize | string): string {
		return this.GetImage(model!, variants!, CameraEnum.PERSPECTIVE, size)

		// if (this.UseRealtime(model?.ProductLineCode)) {
		// 	return this.GetImage(model!, variants!, CameraEnum.PERSPECTIVE, size)
		// }

		// variants = this.adjustForBrandMode(variants, model?.PresentAsPrecious);

		// const imageGetModel = this.GetImageModel(model, modelGroupCode, configurationCode, variants, AngleConstants.Perspective);
		// imageGetModel.ComponentColorList = this.GetComponentParameters(variants);
		// imageGetModel.Angle = AngleConstants.Perspective;

		// return this.GetImageUrl(imageGetModel, size, background);
	}

	// public GetSideImage(model: ModelModel | undefined, modelGroupCode: string | undefined, configurationCode: string | undefined, variants: Array<ComponentVariantModel> | undefined, size: ImageSize | string, background: Background): string {
	public GetSideImage(model: ModelModel | undefined, variants: Array<ComponentVariantModel> | undefined, size: ImageSize | string): string {
		return this.GetImage(model!, variants!, CameraEnum.SIDE, size)

		// if (this.UseRealtime(model?.ProductLineCode)) {
		// 	return this.GetImage(model!, variants!, CameraEnum.SIDE, size)
		// }

		// variants = this.adjustForBrandMode(variants, model?.PresentAsPrecious);

		// const imageGetModel = this.GetImageModel(model, modelGroupCode, configurationCode, variants, AngleConstants.Side);
		// imageGetModel.ComponentColorList = this.GetComponentParameters(variants);
		// imageGetModel.Angle = AngleConstants.Side;

		// return this.GetImageUrl(imageGetModel, size, background);
	}

	// public GetDetailImage(model: ModelModel | null | undefined, modelGroupCode: string | undefined, configurationCode: string | undefined, variants: Array<ComponentVariantModel> | undefined, size: ImageSize | string): string {
	public GetDetailImage(model: ModelModel | null | undefined, variants: Array<ComponentVariantModel> | undefined, size: ImageSize | string): string {
		return this.GetImage(model!, variants!, CameraEnum.DETAIL, size)

		// if (this.UseRealtime(model?.ProductLineCode)) {
		// 	return this.GetImage(model!, variants!, CameraEnum.DETAIL, size)
		// }

		// variants = this.adjustForBrandMode(variants, model?.PresentAsPrecious);

		// const imageGetModel = this.GetImageModel(model, modelGroupCode, configurationCode, variants, AngleConstants.Perspective);
		// imageGetModel.ComponentColorList = this.GetComponentParameters(variants);
		// imageGetModel.Angle = AngleConstants.Detail;

		// return this.GetImageUrl(imageGetModel, size, Background.None);
	}

	// public GetConfigurationDetailImage(model: ModelModel, modelGroupCode: string, configurationCode: string, variants: Array<ComponentVariantModel> | undefined, size: ImageSize | string) {
	public GetConfigurationDetailImage(model: ModelModel, variants: Array<ComponentVariantModel> | undefined, size: ImageSize | string) {
		return this.GetImage(model!, variants!, CameraEnum.DETAIL, size)

		// if (this.UseRealtime(model?.ProductLineCode)) {
		// 	return this.GetImage(model!, variants!, CameraEnum.DETAIL, size)
		// }

		// variants = this.adjustForBrandMode(variants, model.PresentAsPrecious);

		// const imageGetModel = this.GetImageModel(model, modelGroupCode, configurationCode, variants, AngleConstants.Perspective);
		// imageGetModel.ComponentColorList = this.GetComponentParameters(variants);
		// imageGetModel.Angle = AngleConstants.Detail;

		// return this.GetImageUrl(imageGetModel, size, Background.None);
	}

	public GetSliderImages(modelgroup: ModelGroupModel | undefined, model: ModelModel | undefined, modelGroupCode: string | undefined, modelConfigurationCode: string | undefined, variants?: Array<ComponentVariantModel>): Array<ImageModel> {
		// public GetSliderImages(modelgroup: ModelGroupModel | undefined, model: ModelModel | undefined, variants?: Array<ComponentVariantModel>): Array<ImageModel> {
		variants = this.adjustForBrandMode(variants, model?.PresentAsPrecious);

		return this.GetSliderImagesPrivate(modelgroup, model, modelGroupCode, modelConfigurationCode, variants, ImageSize.High, Background.Default);
		// return this.GetSliderImagesPrivate(modelgroup, model, variants, ImageSize.High, Background.Default);
		// return this.GetSliderImagesPrivate(modelgroup, model, variants);
	}

	public GetSliderThumbImages(modelgroup: ModelGroupModel | undefined, model: ModelModel | undefined, modelGroupCode: string | undefined, modelConfigurationCode: string | undefined, variants?: Array<ComponentVariantModel>) {
		// public GetSliderThumbImages(modelgroup: ModelGroupModel | undefined, model: ModelModel | undefined, variants?: Array<ComponentVariantModel>) {
		variants = this.adjustForBrandMode(variants, model?.PresentAsPrecious);

		return this.GetSliderImagesPrivate(modelgroup, model, modelGroupCode, modelConfigurationCode, variants, ImageSize.Medium, Background.None);
		// return this.GetSliderImagesPrivate(modelgroup, model, variants, ImageSize.Medium, Background.None);
		// return this.GetSliderImagesPrivate(modelgroup, model, variants);
	}

	private GetSliderImagesPrivate(modelgroup: ModelGroupModel | undefined, model: ModelModel | undefined, modelGroupCode: string | undefined, modelConfigurationCode: string | undefined, variants: Array<ComponentVariantModel> | undefined, size: ImageSize, background: Background) {
		// private GetSliderImagesPrivate(modelgroup: ModelGroupModel | undefined, model: ModelModel | undefined, variants: Array<ComponentVariantModel> | undefined, size: ImageSize, background: Background) {
		// private GetSliderImagesPrivate(modelgroup: ModelGroupModel | undefined, model: ModelModel | undefined, variants: Array<ComponentVariantModel> | undefined) {
		variants = this.adjustForBrandMode(variants, model?.PresentAsPrecious);

		if (modelgroup?.IsRimless) {
			return [
				// new ImageModel(AngleConstants.Front, this.GetFrontImage(model, modelGroupCode, modelConfigurationCode, variants, "Full", background)),
				// new ImageModel(AngleConstants.Side, this.GetSideImage(model, modelGroupCode, modelConfigurationCode, variants, "Full", background)),
				new ImageModel(AngleConstants.Front, this.GetFrontImage(model, variants, "Full")),
				new ImageModel(AngleConstants.Side, this.GetSideImage(model, variants, "Full")),
			];
		}

		return [
			// new ImageModel(AngleConstants.Perspective, this.GetPerspectiveImage(model, modelGroupCode, modelConfigurationCode, variants, "Full", background)),
			// new ImageModel(AngleConstants.Front, this.GetFrontImage(model, modelGroupCode, modelConfigurationCode, variants, "Full", background)),
			new ImageModel(AngleConstants.Perspective, this.GetPerspectiveImage(model, variants, "Full")),
			new ImageModel(AngleConstants.Front, this.GetFrontImage(model, variants, "Full")),
		];
	}

	// public GetOrderItemImage(orderItem: OrderItemModel, angle: AngleConstants, size: ImageSize | string = ImageSize.Medium, usePreciousCheck: boolean = true) {
	// public GetOrderItemImage(orderItem: OrderItemModel, angle: AngleConstants, size: ImageSize | string = ImageSize.Medium) {
	public GetOrderItemImage(orderItem: OrderItemModel, angle: AngleConstants, frontOrPerspective: boolean = true) {
		return this.getNewImageUrl(orderItem, angle, frontOrPerspective);
	}

	public GetComponentDetailImage(variantCode: string, variantSizeModel: VariantSizeModel): string {
		let size: ImageSize | string = ImageSize.Low;

		if (variantSizeModel.Size) {
			size = variantSizeModel.Size;
		}

		return `${this.getBaseUrl(size)}/component/${variantCode}/?size=${size}`
			+ '&format=webp'
			+ (this.brandModeService.isPrecious ? '&background=precious' : '');
	}

	public GetComponentDetailPreciousImage(componentCode: string, variantCode: string | null, variantSizeModel: VariantSizeModel, modelGroupCode?: string): string {
		let size: ImageSize | string = ImageSize.Low;

		if (variantSizeModel.Size) {
			size = variantSizeModel.Size;
		}

		return `${this.getBaseUrl(size)}/${BrandConstants.PRECIOUS}/${modelGroupCode?.toLowerCase()}/${componentCode.toLowerCase()}/${variantCode?.toLowerCase()}${size}?`
			+ (this.brandModeService.isPrecious ? 'background=' + BrandConstants.PRECIOUS : '');
	}

	public GetNoGemstoneImage(modelGroupCode?: string): string {
		let size: ImageSize | string = ImageSize.Low;

		const noGemstoneImageUrl = `${this.getBaseUrl(size)}/${BrandConstants.PRECIOUS}/${modelGroupCode?.toLowerCase()}/gemstone/plain?`
			+ (this.brandModeService.isPrecious ? 'background=' + BrandConstants.PRECIOUS : '');

		return noGemstoneImageUrl;
	}

	public GetVariantImage(variant: ComponentVariantModel | ComponentVariantFromApiModel, size: ImageSize | string = ImageSize.Low): string {
		let variantCode = variant.Code; //.replace(';POL', '').replace(';SAT', '');

		let url = `${this.getBaseUrl(size)}/component/${variant.Component.Code}/${variantCode}?size=${size}`
			+ '&format=webp'
			+ (this.brandModeService.isPrecious ? '&background=' + BrandConstants.PRECIOUS : '');

		return url;
	}

	// public GetVariantPreciousImage(variant: ComponentVariantModel, modelGroupCode: string | undefined, size: ImageSize | string = ImageSize.Low): string {
	public GetVariantPreciousImage(variant: ComponentVariantModel, size: ImageSize | string = ImageSize.Low): string {
		let code = variant.Code.substring(0, variant.Code.lastIndexOf(';')).toLocaleLowerCase();
		let finish = variant.Code.substring(variant.Code.lastIndexOf(';')).toLocaleLowerCase();

		const url = `${this.getBaseUrl(size)}/${BrandConstants.PRECIOUS}/${variant.Component.Code.toLowerCase()}/${code + finish}?size=${size}`
			+ (this.brandModeService.isPrecious ? '&background=' + BrandConstants.PRECIOUS : '');

		return url;
	}

	// public GetNosepadImage(variant: ComponentVariantModel, modelGroupCode: string | null, size: ImageSize | string = ImageSize.Low): string {
	public GetNosepadImage(variant: ComponentVariantModel, size: ImageSize | string = ImageSize.Low): string {
		let code = variant.Code.substring(0, variant.Code.lastIndexOf(';')).toLocaleLowerCase();
		let finish = variant.Code.substring(variant.Code.lastIndexOf(';')).toLocaleLowerCase();

		const url = `${this.getBaseUrl(size)}/${BrandConstants.PRECIOUS}/${variant.Component.Code.toLowerCase()}/${code + finish}?size=${size}`
			+ (this.brandModeService.isPrecious ? '&background=' + BrandConstants.PRECIOUS : '');

		return url;
	}

	public GetFinishImage(finishName: string | undefined, size: ImageSize | string = ImageSize.Low): string {
		finishName = finishName?.replace(';', '').toLowerCase();

		return `${this.getBaseUrl(size)}/${BrandConstants.PRECIOUS}/finish/${finishName}?size=${size}`
			+ (this.brandModeService.isPrecious ? '&background=' + BrandConstants.PRECIOUS : '');
	}

	public GetComponentInfoImage(variant: ComponentVariantFromApiModel | ComponentVariantModel, type: 'variant' | 'size' | 'color', modelGroupCode?: string) {
		if (modelGroupCode) {
			return `./assets/images/${variant.Component.Code.toLowerCase()}/${modelGroupCode}_${type}_info.svg`;
		}
		else {
			return `./assets/images/${variant.Component.Code.toLowerCase()}/${type}_info.png`;
		}
	}

	public GetVariantInfoImage(variant: ComponentVariantFromApiModel | ComponentVariantModel) {
		return `./assets/icons/${variant.Code}.svg`;
	}

	public GetProductlineImages(ModelgroupCode: string | undefined, mode: ConfigurationMode = ConfigurationMode.undefined, size: ImageSize | string = ImageSize.Low): string {
		let preciousIndicator = '';

		if (this.brandModeService.isPrecious) {
			preciousIndicator = 'Precious_';
		}

		let url = `${this.getBaseUrl(size)}/productlines/${preciousIndicator}${ModelgroupCode}` + (mode != ConfigurationMode.undefined ? `/${mode}` : '') + `?size=${size}`
		url += '&format=webp';
		url += '&background=1';

		return url;
	}

	public GetProductlinePreciousImages(ModelgroupCode: string | undefined, mode: ConfigurationMode = ConfigurationMode.undefined, size: ImageSize | string = ImageSize.Low): string {
		let url = `${this.getBaseUrl(size)}/productlines/Precious_${ModelgroupCode}` + (mode != ConfigurationMode.undefined ? `/${mode}` : '') + `?size=${size}`
		url += '&format=webp';
		url += '&background=1';

		return url;
	}

	public GetInspirationGroupImages(inspirationGroup: string, size: ImageSize | string = ImageSize.Low): string {
		let preciousIndicator = '';

		if (this.brandModeService.isPrecious) {
			preciousIndicator = 'precious_';
		}

		const url = `${this.getBaseUrl(size)}/inspiration/Group/${preciousIndicator}${inspirationGroup}` + '?format=webp';
		return url;
	}

	public GetInspirationImage(inspirationGroup: string | undefined, uuid: string, size: ImageSize | string = ImageSize.Low): string {
		return `${this.getBaseUrl(size)}/inspiration/Photo/${inspirationGroup}/${uuid}` + '?format=webp';
	}

	public GetColorImageUrl(colorLine: string | undefined, colorCode: string | undefined, size: ImageSize | string = ImageSize.Low): string {
		const url = `${this.getBaseUrl(size)}/color/${colorLine}/${colorCode}?size=${ImageSize.Low}` + '&format=webp';

		return url;
	}

	public GetMiscImage(eCommerceNo: string | null | undefined, imageNumber: number, size: string = 'Small'): string {
		return `${this.getBaseUrl(size)}/product/${eCommerceNo}/${imageNumber}/${size}` + '?format=webp';
	}

	public GetMiscCategoryImage(category: string, size: ImageSize | string = ImageSize.Low): string {
		let preciousIndicator = '';

		if (this.brandModeService.isPrecious) {
			preciousIndicator = 'precious_';
		}

		let imageUrl = `${this.getBaseUrl(size)}/product/group/${preciousIndicator}${category}?size=${size}` + '&format=webp';

		return imageUrl;
	}

	public GetMiscGroupImage(group: string, category: string, size: ImageSize | string = ImageSize.Low): string {
		let preciousIndicator = '';

		if (this.brandModeService.isPrecious) {
			preciousIndicator = 'precious_';
		}

		return `${this.getBaseUrl(size)}/product/group/${category}/${preciousIndicator}${group}?size=${size}` + '&format=webp';
	}

	public GetGrooveColorPenImage(size: ImageSize | string = ImageSize.Low): string {
		return `${this.getBaseUrl(size)}/product/GrooveColourPen/1` + '?format=webp';
	}

	public GetTempleInclinationStandardInfoImage() {
		if (this.brandModeService.isPrecious) {
			return `./assets/images/illustration-temple-inclination-standard-precious.svg`;
		}

		return `./assets/images/illustration-temple-inclination-standard.svg`;
	}

	public GetTempleInclinationLowInfoImage() {
		if (this.brandModeService.isPrecious) {
			return `./assets/images/illustration-temple-inclination-low-precious.svg`;
		}

		return `./assets/images/illustration-temple-inclination-low.svg`;
	}

	public GetMiscImageModels(eCommerceNo: string | null | undefined, imageCount: number) {
		const imageModelArrays: Array<Array<MiscImageModel>> = new Array<Array<MiscImageModel>>();

		if (!imageCount || imageCount == 0) {
			const imageModel = this.getMiscImageModel(this.GetMiscImage('', 0), eCommerceNo, 0);
			imageModelArrays.push([imageModel]);
		}
		else if (imageCount == 3) {
			const imageArray = new Array<MiscImageModel>();

			for (let counter = 1; counter < imageCount + 1; counter++) {
				const imageModel = this.getMiscImageModel(this.GetMiscImage(eCommerceNo, counter), eCommerceNo, counter);
				imageArray.push(imageModel);
			}

			imageModelArrays.push(imageArray);
		}
		else {
			let imageArray = new Array<MiscImageModel>();

			for (let counter = 1; counter < imageCount + 1; counter++) {
				if (imageCount == 1) {
					const imageModel = this.getMiscImageModel(this.GetMiscImage(eCommerceNo, counter), eCommerceNo, counter);
					imageModelArrays.push([imageModel]);
				}

				if ((counter % 2) == 0) {
					const imageModel = this.getMiscImageModel(this.GetMiscImage(eCommerceNo, counter), eCommerceNo, counter);
					imageArray.push(imageModel);
					imageModelArrays.push(imageArray);
					imageArray = new Array<MiscImageModel>();
				}
				else {
					const imageModel = this.getMiscImageModel(this.GetMiscImage(eCommerceNo, counter), eCommerceNo, counter);
					imageArray.push(imageModel);
				}
			}
		}

		return imageModelArrays;
	}

	private adjustForBrandMode(variants?: Array<ComponentVariantModel>, presentAsPrecious?: boolean): Array<ComponentVariantModel> | undefined {
		if ((this.brandModeService.isPrecious && this.appState.showPreciousTheme.getValue()) || presentAsPrecious) {
			variants = variants?.filter(v => v.Brand == BrandEnum.Precious || v.Brand == BrandEnum.TitaniumAndPrecious || !v.Brand);
		}
		else {
			variants = variants?.filter(v => v.Brand == BrandEnum.Titanium || v.Brand == BrandEnum.TitaniumAndPrecious || !v.Brand);
		}

		return variants
	}

	public getSKUImage(eCommerceNo: string | null | undefined) {
		if (eCommerceNo) {
			return `${environment.imageCDNUrl}/product/${eCommerceNo}/1/Small?format=webp`;
		}

		return null;
	}

	private getMiscImageModel(src: string, eCommerceNo: string | null | undefined, imageCount: number) {
		const imageModel = new MiscImageModel();
		imageModel.Src = src;
		imageModel.ECommerceNo = eCommerceNo;
		imageModel.ImageCount = imageCount;
		return imageModel;
	}



	public GetPersistedImageUrl(itemUuid: string, sourceType: SourceTypeEnum, camera: CameraEnum, showError: boolean = false): string {
		let url = environment.imageCDNUrl ?? '';
		url += '/persisted/';
		url += sourceType.toString() + '/';
		url += ((itemUuid && itemUuid.length > 0) ? itemUuid + '/' : '');
		url += camera.toString();
		url += '?showerror=' + (showError ? 'true' : 'false');

		return url;
	}

	private http = inject(HttpClient);

	public async getMiscImageCount(eCommerNo: string | null | undefined) {
		const imageUrl = environment.imageCDNUrl;

		const count = await firstValueFrom(this.http.get<number>(`${imageUrl}/product/${eCommerNo}/List`));

		return count;
	}

	public getMiscImageUrl(eCommerceNo: string | null | undefined, imageNumber: number, size: string = 'Small') {
		return `${this.getBaseUrl(size)}/product/${eCommerceNo}/${imageNumber}/${size}` + '?format=webp';
	}


	public getPartsIcon(partName: string) {
		let url = environment.imageCDNUrl ?? '';
		url += '/product/group/parts/';
		url += partName;

		return url;
	}

	private GetImageUrl(imageGetModel: ImageGetModel, size: ImageSize | string = ImageSize.Medium, background: Background = Background.Default, usePreciousCheck: boolean = true): string {
		if (((this.brandModeService.isPrecious && this.appState.showPreciousTheme.getValue()) || imageGetModel.presentAsPrecious) && imageGetModel.ModelGroupCode !== ModelgroupConstants.STRIP3P) {
			background = Background.Precious;
		}

		let url = this.getBaseUrl(size)
			+ '/' + 'model'
			+ '/' + imageGetModel.ModelGroupCode
			+ '/' + (this.getImageModelCode(imageGetModel))
			+ '/' + imageGetModel.Angle;

		if (background === Background.Precious && usePreciousCheck) {
			url = this.getBaseUrl(size)
				+ '/' + BrandConstants.PRECIOUS
				+ '/' + 'model'
				+ '/' + (this.getImageModelCode(imageGetModel));

			return url;
		}
		else if (!usePreciousCheck) {
			background = Background.None;
		}

		let finishParameter = '';
		let variantCode = '';

		imageGetModel.ComponentVariantCode.forEach(code => {
			if (imageGetModel.ModelGroupCode == ModelgroupConstants.STRIP3P || imageGetModel.ModelGroupCode == ModelgroupConstants.SPIRIT) {
				if (imageGetModel.Angle === AngleConstants.Front && code.componentCode === ComponentCodeConstants.Temple) { return; }
				if (imageGetModel.Angle === AngleConstants.Front && code.componentCode === ComponentCodeConstants.BridgeClip) { return; }

				if (imageGetModel.Angle === AngleConstants.Side && code.componentCode === ComponentCodeConstants.Front) { return; }
				if (imageGetModel.Angle === AngleConstants.Side && code.componentCode === ComponentCodeConstants.BridgeClip) { return; }

			}
			variantCode = code.variantCode

			if (variantCode.indexOf(';') > -1) {
				finishParameter = variantCode.substring(code.variantCode.indexOf(';'), code.variantCode.length);
				variantCode = variantCode.replace(finishParameter, '');
			}
			url += '/' + variantCode;

		});

		url += '?';

		if (imageGetModel.ComponentColorList) {
			imageGetModel.ComponentColorList.sortBy(x => x[0]).forEach(componentColorItem => {
				if (imageGetModel.ModelGroupCode == ModelgroupConstants.STRIP3P || imageGetModel.ModelGroupCode == ModelgroupConstants.SPIRIT) {
					if (imageGetModel.Angle === AngleConstants.Front && componentColorItem[0] === ComponentCodeConstants.Temple) { return; }
					if (imageGetModel.Angle === AngleConstants.Front && componentColorItem[0] === ComponentCodeConstants.BridgeClip) { return; }
					if (imageGetModel.Angle === AngleConstants.Side && componentColorItem[0] === ComponentCodeConstants.Front) { return; }
					if (imageGetModel.Angle === AngleConstants.Side && componentColorItem[0] === ComponentCodeConstants.BridgeClip) { return; }
					if (imageGetModel.Angle === AngleConstants.Side && componentColorItem[0] === ComponentCodeConstants.Bridge) { return; }
				}

				if (componentColorItem[0] === ComponentCodeConstants.Front) {
					finishParameter = '';
				}

				if (componentColorItem[0] === ComponentCodeConstants.Lenses) {
					url += componentColorItem[0] + '=' + componentColorItem[1] + componentColorItem[2] + finishParameter + '&';
				}
				else {
					url += componentColorItem[0] + '=' + componentColorItem[1] + finishParameter + '&';
				}
			});
		}

		url += 'CONF=' + imageGetModel.ConfigurationCode;
		url += '&size=' + size;
		url += '&format=webp';
		url += '&background=0'

		return url;
	}

	getNewImageUrl(sourceModel: OrderItemModel, angle: AngleConstants, frontOrPerspective: boolean = true) {
		let imageUrl = environment.realtimeUrl;

		imageUrl += '/image/';

		if (frontOrPerspective) {
			if (angle === AngleConstants.Front) {
				imageUrl += 'Front';
			}
			else {
				imageUrl += 'Perspective';
			}
		}
		else {
			imageUrl += 'Side';
		}

		imageUrl += '/Medium';

		imageUrl += '?';

		imageUrl += 'productline=';
		imageUrl += sourceModel.ModelGroupCode;

		imageUrl += '&isRimless=';
		imageUrl += sourceModel.IsRimless;

		imageUrl += '&MODEL=';
		imageUrl += sourceModel.ModelCode?.toUpperCase();
		imageUrl += '+';
		imageUrl += sourceModel.ModelSizeCode?.replace('#', `□`).replace('¤', `○`);
		imageUrl += '+';

		sourceModel.OrderLines.sortBy(x => x.ComponentCode).forEach(component => {
			var cs = '&' + component.ComponentCode + '=' + component.ComponentVariantCode?.replace(' ', '') + '+' + component.ComponentSizeCode + '+' + component.ColorLineCode?.replace(' ', '-') + '/' + component.ColorCode;

			imageUrl += cs;
		});


		return imageUrl;
	}

	private getImageModelCode(imageGetModel: ImageGetModel) {
		if (imageGetModel.Angle === AngleConstants.Side && (imageGetModel.ModelGroupCode === ModelgroupConstants.STRIP3P || imageGetModel.ModelGroupCode === ModelgroupConstants.SPIRIT)) {
			return 2000;
		}

		return imageGetModel.ModelCode;
	}

	private getBaseUrl(size: string | null) {
		return size === ImageSize.High ? environment.imageUrl : environment.imageCDNUrl;
	}

	private GetImageModel(model: ModelModel | undefined | null, modelGroupCode: string | undefined, configurationCode: string | undefined, variants: Array<ComponentVariantModel> | undefined, angle: AngleConstants): ImageGetModel {
		const imageGetModel = new ImageGetModel();
		imageGetModel.ModelGroupCode = modelGroupCode;
		imageGetModel.ModelCode = model?.Code;
		imageGetModel.ConfigurationCode = configurationCode;
		imageGetModel.ComponentVariantCode = [];
		imageGetModel.presentAsPrecious = model?.PresentAsPrecious;

		const defaultTemple = variants?.find((obj) => obj.Component.Code == ComponentCodeConstants.Temple);
		if (defaultTemple) {
			imageGetModel.ComponentVariantCode.push({ variantCode: defaultTemple.Code, componentCode: defaultTemple.Component.Code });
		}

		const defaultInnerrim = variants?.find((obj) => obj.Component.Code == ComponentCodeConstants.Innerrim);
		if (defaultInnerrim) {
			imageGetModel.ComponentVariantCode.push({ variantCode: defaultInnerrim.Code, componentCode: defaultInnerrim.Component.Code });
		}

		const bridge = variants?.find(x => x.Component.Code == ComponentCodeConstants.Bridge);
		if (bridge && angle == AngleConstants.Front) {
			imageGetModel.ComponentVariantCode.push({ variantCode: bridge.Code, componentCode: bridge.Component.Code });
		}

		return imageGetModel;
	}

	private GetComponentParameters(componentVariantModels?: Array<ComponentVariantModel>): Array<[string, string | undefined, string | undefined]> {
		const componentColorList: Array<[string, string | undefined, string | undefined]> = new Array<[string, string, string | undefined]>();

		if (componentVariantModels && componentVariantModels.length > 0) {
			componentVariantModels?.forEach(variantModel => {
				const componentName = variantModel.Component.Code;

				if (variantModel.VariantColor) {
					const defaultColor = variantModel.VariantColor;

					if (componentName == ComponentCodeConstants.Lenses) {
						componentColorList.push([componentName, defaultColor.Color?.Code, variantModel.VariantColor.Color?.ColorLine?.Code]);
					} else {
						componentColorList.push([componentName, defaultColor.Color?.Code, variantModel.Code]);
					}
				}
			});
		}

		return componentColorList;
	}

	public async GetLimited(code: string) {
		let iat = new ImageAndThumb(
			`${this.getBaseUrl(null)}/precious/limited/large/${code}.png` + '?format=webp',
			`${this.getBaseUrl(null)}/precious/limited/small/${code}.png` + '?format=webp'
		)

		return iat;
	}

	public GetProductlineImagesByBrand(ModelgroupCode: string | undefined, isPrecious: boolean = false): string {
		let preciousIndicator = isPrecious ? 'Precious_' : '';

		const url = `${this.getBaseUrl(ImageSize.Low)}/productlines/${preciousIndicator}${ModelgroupCode}`;
		return url + `?size=${ImageSize.Low}` + '&format=webp';
	}

	public GetPartsTileImage(): string {
		let preciousIndicator = '';

		if (this.brandModeService.isPrecious) {
			preciousIndicator = 'Precious_';
		}

		let url = `${this.getBaseUrl(ImageSize.Low)}/productlines/${preciousIndicator}parts?size=low`;
		url += '&format=webp';

		return url;
	}

}
